import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL_DETRAN, PATH_CONTABILIZA } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, EventoInicioSessaoRequest } from './types';

// ACTIONS
import {
	eventoInicioSessaoSuccess,
	eventoInicioSessaoFailure,
} from './actions';

function* eventoInicioSessao(request: ReducerAction) {
	const { payload }: { payload: EventoInicioSessaoRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_CONTABILIZA,
		`evento/${CHANNEL_DETRAN}/inicio`,
		payload.dataPayload,
		undefined,
		true,
	);

	if (response.status === 200) {
		yield put(
			eventoInicioSessaoSuccess({
				response,
				request: payload.detailsStartSection,
			}),
		);
	} else {
		yield put(
			eventoInicioSessaoFailure({
				response,
				request: payload.detailsStartSection,
			}),
		);
	}
}

export default all([
	takeLatest(Types.EVENTO_INICIO_SESSAO_REQUEST, eventoInicioSessao),
]);
